import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListsService } from 'src/app/lists/services/lists.service';
import { SortableSectionHeader } from '../../../../shared/components/sortable-section/models/sortable-section.model';
import { ListsOverlayService } from '../../../services/lists-overlay.service';
import { ListSectionBaseComponent } from '../list-section-base.component';

@Component({
  selector: 'app-list-section-desktop-tablet',
  templateUrl: './list-section-desktop-tablet.component.html',
  styleUrls: [
    '../../../../shared/components/sortable-section/desktop-tablet/sortable-section-desktop-tablet.component.scss',
    './list-section-desktop-tablet.component.scss',
  ],
})
export class ListSectionDesktopTabletComponent extends ListSectionBaseComponent {
  @Input() sectionName: string;

  constructor(
    translateService: TranslateService,
    listsService: ListsService,
    listsOverlayService: ListsOverlayService,
  ) {
    super(translateService, listsService, listsOverlayService);
  }

  updateListOfListsSort(event: SortableSectionHeader) {
    this.listsService.updateListOfListsSort(
      this.sectionName,
      event?.headerName,
      event?.sortDirection,
    );
  }
}
